/* src/app/shared/components/checklist-table/checklist-table.component.scss */
.mat-mdc-table {
  background: var(--tds-grey-50);
  width: 100%;
  table-layout: fixed;
  --mat-table-header-headline-font: var(--tds-body-02);
  --mat-table-row-item-label-text-font: var(--tds-body-02);
}
.data-table__action {
  width: 60px;
}
::ng-deep .mat-mdc-sort-header-content {
  line-height: 16px;
}
.mat-mdc-table thead,
.mat-mdc-table tbody,
.mat-mdc-table tfoot,
mat-header-row,
mat-row,
mat-footer-row,
[mat-header-row],
[mat-row],
[mat-footer-row],
.mat-mdc-table-sticky {
  background: inherit;
}
mat-row,
mat-header-row,
mat-footer-row,
mat-header-cell,
th.mat-mdc-header-cell,
td.mat-mdc-cell,
td.mat-mdc-footer-cell {
  font-size: 1.4rem;
  line-height: 1.6rem;
}
tr.mat-mdc-header-row {
  height: auto !important;
}
mat-row,
[mat-row],
.mat-mdc-row {
  background-color: var(--tds-white);
}
mat-row:nth-child(even),
[mat-row]:nth-child(even),
.mat-mdc-row:nth-child(even) {
  background-color: var(--tds-grey-50);
}
:host.on-white mat-row,
:host.on-white [mat-row],
:host.on-white .mat-mdc-row {
  background-color: var(--tds-grey-50);
}
.mat-mdc-header-cell {
  color: var(--tds-black);
  background-color: var(--tds-grey-200) !important;
  font-weight: bold;
  padding: 16px;
}
.mat-mdc-header-cell:first-child {
  border-top-left-radius: var(--radius-area-small);
}
.mat-mdc-header-cell:last-child {
  border-top-right-radius: var(--radius-area-small);
}
.mat-mdc-cell,
.mat-mdc-footer-cell {
  color: var(--tds-black);
  padding: 16px;
  border-bottom-color: var(--tds-grey-100);
  word-break: break-word;
}
/*# sourceMappingURL=checklist-table.component.css.map */
